module.exports = __webpack_public_path__ + "static/media/knet.3af18031.svg";